'use client';
import * as React from 'react';
import { type FC, type ReactNode } from 'react';
import { type Locale } from 'dibs-intl/exports/locales';
import { createIntl } from './createIntl.ts';
import { IntlContext } from './IntlContext.tsx';

type Props = {
    messages?: Record<string, string>;
    locale: Locale;
    defaultLocale?: string;
    disableTranslations?: boolean;
    children: ReactNode;
};

export const IntlProvider: FC<Props> = ({ messages, locale, children, disableTranslations }) => {
    const intl = createIntl({ locale, messages, defaultLocale: 'en-US', disableTranslations });
    return <IntlContext value={intl}>{children}</IntlContext>;
};
